import './unauthorized.css'

export default function Unauthorized() {

    return (
        <div className="unauthorized_text">
            <h1>Unauthorized - Woahhh there buddy! ❌</h1>
            <p>You are not authorized to view this page. If you believe that this is a mistake, please contact a developer.</p>

            <a href="/">Return to the home page</a>
        </div>
    )   
}
